module.exports = {
	"id": "CA",
	"name": "Canada",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.013044,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.006522,
			"22": 0.019566,
			"23": null,
			"24": null,
			"25": 0.006522,
			"26": 0.006522,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.078264,
			"32": 0.013044,
			"33": 0.019566,
			"34": 0.026088,
			"35": 0.026088,
			"36": 0.026088,
			"37": 0.026088,
			"38": 0.039132,
			"39": 0.045654,
			"40": 0.026088,
			"41": 0.045654,
			"42": 0.045654,
			"43": 0.176094,
			"44": 0.045654,
			"45": 0.13044,
			"46": 0.06522,
			"47": 0.06522,
			"48": 0.16305,
			"49": 1.741374,
			"50": 0.306534,
			"51": 1.56528,
			"52": 0.776118,
			"53": 21.724782,
			"54": 5.406738,
			"55": 0.052176,
			"56": 0.019566,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.013044,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.006522,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.013044,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.006522,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.013044,
			"29": 0.006522,
			"30": 0.006522,
			"31": 0.026088,
			"32": 0.006522,
			"33": 0.013044,
			"34": 0.026088,
			"35": 0.019566,
			"36": 0.026088,
			"37": 0.013044,
			"38": 0.091308,
			"39": 0.03261,
			"40": 0.026088,
			"41": 0.045654,
			"42": 0.03261,
			"43": 0.169572,
			"44": 0.045654,
			"45": 0.19566,
			"46": 0.16305,
			"47": 0.75003,
			"48": 0.61959,
			"49": 5.993718,
			"50": 0.071742,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.013044
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.013044,
			"37": 0.013044,
			"38": 0.247836,
			"39": 0.006522,
			"40": 0.176094,
			"41": 0.03261,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.019566
		},
		"safari": {
			"0": null,
			"4": 0.013044,
			"5": 0.071742,
			"6": 0.013044,
			"7": 0.35871,
			"8": 0.280446,
			"9": 0.593502,
			"10": 2.484882,
			"3.1": null,
			"3.2": null,
			"5.1": 0.19566,
			"6.1": 0.763074,
			"7.1": 0.241314,
			"9.1": 4.115382
		},
		"ios_saf": {
			"8": 0,
			"10": 11.7318281823,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.316159194317,
			"8.1-8.4": 0.584090714925,
			"9.0-9.2": 0.278648781432,
			"9.3": 4.25118012698
		},
		"android": {
			"3": 0,
			"4": 0.0141587209302,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00176984011628,
			"4.1": 0.0510725290698,
			"4.2-4.3": 0.127681322674,
			"4.4": 0.292782122093,
			"4.4.3-4.4.4": 0.295310465116
		},
		"ie": {
			"6": null,
			"7": 0.0130971107492,
			"8": 0.189908105863,
			"9": 0.281587881107,
			"10": 0.24229654886,
			"11": 7.31473635342,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0422261035273,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0011729473202
		},
		"edge": {
			"12": 0.052176,
			"13": 0.541326,
			"14": 2.719674
		},
		"ie_mob": {
			"10": 0.023324,
			"11": 0.094962
		},
		"bb": {
			"7": 0.490539,
			"10": null
		},
		"samsung": {
			"0": 3.426815
		},
		"and_uc": {
			"0": 0.250488
		},
		"op_mini": {
			"0": 0.568904949153
		},
		"and_chr": {
			"0": 11.525275
		},
		"and_ff": {
			"0": 0.045227
		}
	},
	"total": 96.561754
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/CA.json
 ** module id = 489
 ** module chunks = 0
 **/